import React, { memo } from 'react';
import Skeleton from './Skeleton';

const ChartSkeleton = memo(function ChartSkeleton({ height = 240, style = {} }) {
  return (
    <div
      aria-busy="true"
      style={{
        background: '#FFFFFF',
        borderRadius: 14,
        border: '1.5px solid var(--border, #E5E7EB)',
        padding: 20,
        width: '100%',
        ...style,
      }}
    >
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 20 }}>
        <div>
          <Skeleton variant="text" width={160} height={18} style={{ marginBottom: 4 }} />
          <Skeleton variant="text" width={100} height={12} />
        </div>
        <Skeleton variant="rectangular" width={90} height={28} borderRadius={8} />
      </div>

      <div style={{ display: 'flex', alignItems: 'flex-end', gap: 12, height: height - 60, paddingTop: 20 }}>
        {Array.from({ length: 8 }).map((_, idx) => {
          const h = [40, 65, 30, 85, 50, 95, 70, 60][idx % 8];
          return (
            <div key={idx} style={{ flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', height: '100%', justifyContent: 'flex-end' }}>
              <Skeleton variant="rectangular" width="100%" height={`${h}%`} borderRadius={6} />
              <Skeleton variant="text" width="60%" height={10} style={{ marginTop: 8 }} />
            </div>
          );
        })}
      </div>
    </div>
  );
});

export default ChartSkeleton;
